import React from 'react';
import { AlertCircle, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  metaHealthAlertCopy,
  openMetaBusinessSupport,
  type MetaHealthStatus,
} from '@/lib/metaAccountHealth';

interface CriticalAccount {
  phone_number?: string;
  display_name?: string;
  meta_health_status?: string | null;
}

interface MetaAccountHealthBannerProps {
  accounts: CriticalAccount[];
  className?: string;
}

/**
 * Banner on Campañas home when any WhatsApp account is restricted or blocked.
 * Limited does not trigger this banner. Copy attributes the issue to Meta.
 */
export const MetaAccountHealthBanner: React.FC<MetaAccountHealthBannerProps> = ({
  accounts,
  className = '',
}) => {
  if (!accounts.length) return null;

  const primary = accounts[0];
  const status = (primary.meta_health_status || 'restricted') as MetaHealthStatus;
  const { title, body } = metaHealthAlertCopy(status);
  const extra =
    accounts.length > 1
      ? ` Afecta a ${accounts.length} cuentas conectadas.`
      : '';

  return (
    <div className={`bg-red-50 border-red-200 border rounded-xl p-4 shadow-sm ${className}`}>
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <div className="flex items-start gap-3 flex-1 min-w-0">
          <AlertCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" />
          <div className="min-w-0">
            <p className="text-sm font-medium text-red-800">{title}</p>
            <p className="text-sm text-red-700 mt-0.5">
              {body}
              {extra}
            </p>
          </div>
        </div>
        <Button
          type="button"
          size="sm"
          onClick={openMetaBusinessSupport}
          className="bg-gradient-to-r from-[#1F4068] to-[#1CB3B3] text-white hover:opacity-90 shrink-0 h-9 px-4 rounded-lg font-semibold shadow-sm"
        >
          Revisar en Meta Business
          <ExternalLink className="h-3.5 w-3.5 ml-1.5" />
        </Button>
      </div>
    </div>
  );
};

export default MetaAccountHealthBanner;
